import type { OrgModelProjection } from '../models/OrgModelProjection';

/**
 * Resolves the deterministic Full Org projection node for a Position. Filled
 * seats render as their primary person record; vacant seats use the projection
 * node id owned by buildPeopleChartScene.
 */
export function resolveSuccessionAuthoringShapeId(input: {
  positionId: string;
  model?: Pick<OrgModelProjection, 'positionState'>;
}): string | null {
  const state = input.model?.positionState.find((candidate) => candidate.positionId === input.positionId);
  const occupantId = state?.primaryOccupantPersonId
    ?? (state?.occupantPersonIds.length === 1 ? state.occupantPersonIds[0] : null);
  if (occupantId) return occupantId;
  return state?.vacant && state.occupantPersonIds.length === 0
    ? `open-seat:${input.positionId}`
    : null;
}

export function successionAuthoringUrl(input: {
  folderId: string;
  diagramId: string;
  shapeId: string;
  reviewId: string;
}): string {
  const search = new URLSearchParams({ review: input.reviewId, shape: input.shapeId });
  return `/f/${encodeURIComponent(input.folderId)}/d/${encodeURIComponent(input.diagramId)}?${search}`;
}
